import React from 'react';
import OtherIncomeEarnerChatComposer from '../otherIncomeEarner/OtherIncomeEarnerChatComposer';
import RetirementAllowanceChatComposer from '../retirementAllowance/RetirementAllowanceChatComposer';
import type { OtherIncomeEarnerFlow } from '../otherIncomeEarner/useOtherIncomeEarnerFlow';
import type { RetirementAllowanceFlow } from '../retirementAllowance/useRetirementAllowanceFlow';

export type OtherClaimsPhase = 'otherIncome' | 'retirement';

export default function OtherClaimsChatComposer({
  phase,
  otherIncomeFlow,
  retirementFlow,
  wheelLocale,
}: {
  phase: OtherClaimsPhase;
  otherIncomeFlow: OtherIncomeEarnerFlow;
  retirementFlow: RetirementAllowanceFlow;
  wheelLocale: string;
}) {
  if (phase === 'retirement') {
    return <RetirementAllowanceChatComposer flow={retirementFlow} />;
  }
  return <OtherIncomeEarnerChatComposer flow={otherIncomeFlow} wheelLocale={wheelLocale} />;
}
